import React from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import About from './components/About'
import Projects from './components/Projects'
import Interests from './components/Interests'
import Travel from './components/Travel'
import Contact from './components/Contact'
import Footer from './components/Footer'

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        <Hero />
        <About />
        <Projects />
        <Interests />
        <Travel />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}

export default App 